<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import downloader from '@/mixins/downloader';
import snackbarMixin from '@/mixins/snackbar';
import RbxConfirmDialog from '@/shared/reybex/RbxConfirmDialog';

export default {
  name: 'TrainingEditorListItem',
  components: {
    RbxConfirmDialog,
  },
  mixins: [downloader, snackbarMixin],
  props: {
    training: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: 'Soll die Schulung gelöscht werden?',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.isConfirmDialogDisplayed = false;

      axios.delete(`/training/${this.training.id}`)
        .then(() => {
          this.showSuccessMessage('Die Schulung wurde gelöscht.');

          this.$emit('delete');
        })
        .catch(() => {
          this.showErrorMessage('Ein technischer Fehler ist aufgetreten. Der Löschvorgang ist fehlgeschlagen.');
        });
    },
  },
};
</script>

<template>
  <tr>
    <td><router-link :to="`/trainingEditor/${training.id}`">{{ training.name }}</router-link></td>
    <td>
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDeleteRights"
               @click.native="onDelete" flat icon slot="activator" :disabled="training.isDelete">
          <v-icon color="red lighten-2" small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </tr>
</template>
